import { useCallback } from "react";
import { useApolloClient, gql } from "@apollo/client";
import { DeleteProgramVariables } from "../__generated__/gql-types/DeleteProgram";

const useDeleteProgram = () => {
  const client = useApolloClient();
  return useCallback(
    async (input: DeleteProgramVariables) => {
      return await client.mutate({
        mutation: DELETE_PROGRAM,
        fetchPolicy: "no-cache",
        variables: input,
      });
    },
    [client]
  );
};

export default useDeleteProgram;

const DELETE_PROGRAM = gql`
  mutation DeleteProgram($deleteProgramId: ID!) {
    deleteProgram(id: $deleteProgramId) {
      id
      title
      deleted_at
    }
  }
`;
